import {
    Mail,
    Phone,
    MapPin,
    User,
    Store,
    BadgeCheck,
} from "lucide-react";

import "./ProviderCards.css";
import getImageUrl from "../../../utils/imageUrl";

function ProviderProfileCard({ provider }) {

    const image = provider.photos?.profilePhoto
        ? getImageUrl(
            `/uploads/provider/${provider.photos.profilePhoto}`
        )
        : "/images/default-user.png";

    return (

        <div className="provider-card provider-profile-card">

            <div className="provider-profile-header">

                <img
                    src={image}
                    alt={provider.ownerName || "Provider"}
                    className="profile-image"
                    onError={(e) => {
                        e.currentTarget.src =
                            "/images/default-user.png";
                    }}
                />

                <div className="provider-profile-info">

                    <div className="provider-top-row">

                        <h2>
                            {provider.business?.businessName ||
                                "Unnamed Business"}
                        </h2>

                        <span
                            className={`provider-status ${
                                provider.status?.toLowerCase() || ""
                            }`}
                        >
                            <BadgeCheck size={15} />
                            {provider.status || "Unknown"}
                        </span>

                    </div>

                    <div className="provider-owner">

                        <User size={17} />

                        <span>
                            {provider.ownerName || "N/A"}
                        </span>

                    </div>

                    <div className="provider-badges">

                        <span className="provider-type-badge">

                            <Store size={15} />

                            {provider.providerType || "Provider"}

                        </span>

                    </div>

                </div>

            </div>

            <div className="provider-contact-grid">

                <div className="contact-item">

                    <Phone size={18} />

                    <span>
                        {provider.phone || "N/A"}
                    </span>

                </div>

                <div className="contact-item">

                    <Mail size={18} />

                    <span>
                        {provider.email || "N/A"}
                    </span>

                </div>

                <div className="contact-item">

                    <MapPin size={18} />

                    <span>
                        {provider.address?.city || "N/A"}
                        {provider.address?.state
                            ? `, ${provider.address.state}`
                            : ""}
                    </span>

                </div>

                <div className="contact-item">

                    <User size={18} />

                    <span>
                        {provider.gender || "Not Specified"}
                    </span>

                </div>

            </div>

        </div>
    );
}

export default ProviderProfileCard;